import React from 'react';



type Props = {
  className?: string;
}
export const InspectionMenuViewVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '20' height = '20' viewBox = '0 0 20 20' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = 'currentColor' strokeWidth = '1.8' d = 'M1 11.2L6 16H14L19 11.2V8.8L14 4H6L1 8.8V11.2Z' />
      <path stroke = 'currentColor' strokeWidth = '1.5' d = 'M8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8' />
    </svg>
  );
};

